import { render, staticRenderFns } from "./EmissionConsolidationMethod.vue?vue&type=template&id=10b5456c"
import script from "./EmissionConsolidationMethod.vue?vue&type=script&lang=js"
export * from "./EmissionConsolidationMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports